import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Column = _resolveComponent("Column")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.fieldsMetadata')), 1)
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        class: "p-datatable-sm kn-table kn-table-small-input",
        autoLayout: true,
        value: _ctx.fieldsMetadata,
        responsiveLayout: "stack",
        breakpoint: "960px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "fieldAlias",
            header: _ctx.$t('managers.datasetManagement.fieldAlias'),
            sortable: true
          }, {
            body: _withCtx(({data}) => [
              _createTextVNode(_toDisplayString(data.fieldAlias), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "Type",
            header: _ctx.$t('importExport.catalogFunction.column.type'),
            sortable: true
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_Dropdown, {
                class: "kn-material-input",
                style: _ctx.linkTabDescriptor.style.maxwidth,
                modelValue: data.Type,
                "onUpdate:modelValue": ($event: any) => (data.Type = $event),
                options: _ctx.valueTypes,
                optionDisabled: "disabled",
                optionLabel: "value",
                optionValue: "name",
                onChange: _ctx.warnForDuplicateSpatialFields,
                disabled: true
              }, null, 8, ["style", "modelValue", "onUpdate:modelValue", "options", "onChange"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "fieldType",
            header: _ctx.$t('managers.datasetManagement.fieldType'),
            sortable: true
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_Dropdown, {
                class: "kn-material-input",
                style: _ctx.linkTabDescriptor.style.maxwidth,
                modelValue: data.fieldType,
                "onUpdate:modelValue": ($event: any) => (data.fieldType = $event),
                options: _ctx.fieldMetadataTypes,
                optionLabel: "value",
                optionValue: "value",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.warnForDuplicateSpatialFields('fieldType')))
              }, null, 8, ["style", "modelValue", "onUpdate:modelValue", "options"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            hidden: "true",
            field: "personal",
            header: _ctx.$t('managers.datasetManagement.personal'),
            sortable: true
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_Checkbox, {
                id: "personal",
                modelValue: data.personal,
                "onUpdate:modelValue": ($event: any) => (data.personal = $event),
                binary: true,
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.warnForDuplicateSpatialFields('personal')))
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            hidden: "true",
            field: "decrypt",
            header: _ctx.$t('managers.datasetManagement.decrypt'),
            sortable: true
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_Checkbox, {
                id: "decrypt",
                modelValue: data.decrypt,
                "onUpdate:modelValue": ($event: any) => (data.decrypt = $event),
                binary: true,
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.warnForDuplicateSpatialFields('decrypt')))
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            hidden: "true",
            field: "subjectId",
            header: _ctx.$t('managers.datasetManagement.subjectId'),
            sortable: true
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_Checkbox, {
                id: "subjectId",
                modelValue: data.subjectId,
                "onUpdate:modelValue": ($event: any) => (data.subjectId = $event),
                binary: true,
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.warnForDuplicateSpatialFields('subjectId')))
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }))
}